/*
* --------------------- Custom Recharge ---------------------
* All the code below is to customise the view and functionality of each Recharge admin section
*/


//JSON Object for box and flavour swaps
boxes_and_flavours = [
  {
    'title': 'Snack Box (4 x 35g bags)',
    'product_id': 6817805041856, //need to change
    'variant_id': 40398267351232, //need to change 
    'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/8_x_35.jpg?v=1616677347',
    'size': 4,
    'price': 10.99,
    'flavours': [
      {
        'title': 'Cracked Pepper',
        'product_id': 6792177254592,
        'variant_id': 40297881567424,
        'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/cp.png?v=1627298119',
        'description': "Wonderfully peppery biltong made according to our signature recipe and air-dried to perfection.",
      },
      {
        'title': 'BBQ',
        'product_id': 6183000735936,
        'variant_id': 38046939578560,
        'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/flavour-full_bbq.png?v=1613066473',
        'description': "Our brand new flavour! It's smokey, it's spicy, it's perfect.",
      },
      {
        'title': 'Wild Venison',
        'product_id': 6584060248256,
        'variant_id': 39431284195520,
        'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/venison_singl.png?v=1627336837',
        'description': 'Try our new pasture-fed, super lean, super wild, super tasty venison biltong',
      },
      {
        'title': 'The Original',
        'product_id': 1749088108642,
        'variant_id': 16299959812194,
        'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/flavour-full_the_original.png?v=1600981700',
        'description': 'Original flavour uses base spices of ground coriander seeds, salt and pepper mixed with worcester sauce and malt vinegar.',
      },
      {
        'title': 'Peri Peri',
        'product_id': 1749049475170,
        'variant_id': 16299647008866,
        'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/flavour-full_peri_peri.png?v=1600985731',
        'description': 'Peri-Peri flavour uses base spices of ground coriander seeds, salt and pepper mixed with worcester sauce and malt vinegar, with added peri-peri for that extra kick.',
      },
      {
        'title': 'Chilli Chutney',
        'product_id': 1749094793314,
        'variant_id': 16300022464610,
        'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/flavour-full_chilli_chutney.png?v=1600981701',
        'description': 'Chilli-Chutney flavour uses base spices of ground coriander seeds, salt and pepper mixed with worcester sauce and malt vinegar, with added chilli chutney for that awesome sweet and spicy taste.',
      },
      {
        'title': 'Garlic',
        'product_id': 1749090762850,
        'variant_id': 16299985797218,
        'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/flavour-full_garlic.png?v=1600981700',
        'description': 'Garlic flavour uses base spices of ground coriander seeds, salt and pepper mixed with worcester sauce and malt vinegar mixed with garlic salts.',
      },
      {
        'title': 'Original Drywors',
        'product_id': 1749040660578,
        'variant_id': 16299561484386,
        'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/flavour-full_original_drywors.png?v=1600981700',
        'description': 'Using quality ingredients (extra lean beef) mixed with authentic coriander ground spice, salt, pepper. Nothing more.',
      },
      {
        'title': 'GO m-eat!',
        'product_id': 1749097447522,
        'variant_id': 16300052283490,
        'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/flavour-full_go_m-eat.png?v=1600983706',
        'description': 'This high protein biltong snack is full of flavour yet low in sugar, lean and low in carbs.',
      }
    ]
  },
  {
    'title': 'Snack Box Subscription (4 x 35g bags)',
    'product_id': 14628722835834, //need to change
    'variant_id': 51661570736506, //need to change 
    'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/8_x_35.jpg?v=1616677347',
    'size': 4,
    'price': 10.99,
    'flavours': [
      {
        'title': 'Cracked Pepper',
        'product_id': 6792177254592,
        'variant_id': 40297881567424,
        'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/cp.png?v=1627298119',
        'description': "Wonderfully peppery biltong made according to our signature recipe and air-dried to perfection.",
      },
      {
        'title': 'BBQ',
        'product_id': 6183000735936,
        'variant_id': 38046939578560,
        'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/flavour-full_bbq.png?v=1613066473',
        'description': "Our brand new flavour! It's smokey, it's spicy, it's perfect.",
      },
      {
        'title': 'Wild Venison',
        'product_id': 6584060248256,
        'variant_id': 39431284195520,
        'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/venison_singl.png?v=1627336837',
        'description': 'Try our new pasture-fed, super lean, super wild, super tasty venison biltong',
      },
      {
        'title': 'The Original',
        'product_id': 1749088108642,
        'variant_id': 16299959812194,
        'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/flavour-full_the_original.png?v=1600981700',
        'description': 'Original flavour uses base spices of ground coriander seeds, salt and pepper mixed with worcester sauce and malt vinegar.',
      },
      {
        'title': 'Peri Peri',
        'product_id': 1749049475170,
        'variant_id': 16299647008866,
        'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/flavour-full_peri_peri.png?v=1600985731',
        'description': 'Peri-Peri flavour uses base spices of ground coriander seeds, salt and pepper mixed with worcester sauce and malt vinegar, with added peri-peri for that extra kick.',
      },
      {
        'title': 'Chilli Chutney',
        'product_id': 1749094793314,
        'variant_id': 16300022464610,
        'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/flavour-full_chilli_chutney.png?v=1600981701',
        'description': 'Chilli-Chutney flavour uses base spices of ground coriander seeds, salt and pepper mixed with worcester sauce and malt vinegar, with added chilli chutney for that awesome sweet and spicy taste.',
      },
      {
        'title': 'Garlic',
        'product_id': 1749090762850,
        'variant_id': 16299985797218,
        'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/flavour-full_garlic.png?v=1600981700',
        'description': 'Garlic flavour uses base spices of ground coriander seeds, salt and pepper mixed with worcester sauce and malt vinegar mixed with garlic salts.',
      },
      {
        'title': 'Original Drywors',
        'product_id': 1749040660578,
        'variant_id': 16299561484386,
        'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/flavour-full_original_drywors.png?v=1600981700',
        'description': 'Using quality ingredients (extra lean beef) mixed with authentic coriander ground spice, salt, pepper. Nothing more.',
      },
      {
        'title': 'GO m-eat!',
        'product_id': 1749097447522,
        'variant_id': 16300052283490,
        'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/flavour-full_go_m-eat.png?v=1600983706',
        'description': 'This high protein biltong snack is full of flavour yet low in sugar, lean and low in carbs.',
      }
    ]
  },
  {
    'title': 'Snack Box (4 x 35g bags)',
    'product_id': 6817805041856, //need to change
    'variant_id': 40398471823552, //need to change
    'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/8_x_35.jpg?v=1616677347',
    'size': 4,
    'price': 10.99,
    'flavours': [
      {
        'title': 'Cracked Pepper',
        'product_id': 6792177254592,
        'variant_id': 40297881567424,
        'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/cp.png?v=1627298119',
        'description': "Wonderfully peppery biltong made according to our signature recipe and air-dried to perfection.",
      },
      {
        'title': 'BBQ',
        'product_id': 6183000735936,
        'variant_id': 38046939578560,
        'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/flavour-full_bbq.png?v=1613066473',
        'description': "Our brand new flavour! It's smokey, it's spicy, it's perfect.",
      },
      {
        'title': 'Wild Venison',
        'product_id': 6584060248256,
        'variant_id': 39431284195520,
        'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/venison_singl.png?v=1627336837',
        'description': 'Try our new pasture-fed, super lean, super wild, super tasty venison biltong',
      },
      {
        'title': 'The Original',
        'product_id': 1749088108642,
        'variant_id': 16299959812194,
        'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/flavour-full_the_original.png?v=1600981700',
        'description': 'Original flavour uses base spices of ground coriander seeds, salt and pepper mixed with worcester sauce and malt vinegar.',
      },
      {
        'title': 'Peri Peri',
        'product_id': 1749049475170,
        'variant_id': 16299647008866,
        'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/flavour-full_peri_peri.png?v=1600985731',
        'description': 'Peri-Peri flavour uses base spices of ground coriander seeds, salt and pepper mixed with worcester sauce and malt vinegar, with added peri-peri for that extra kick.',
      },
      {
        'title': 'Chilli Chutney',
        'product_id': 1749094793314,
        'variant_id': 16300022464610,
        'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/flavour-full_chilli_chutney.png?v=1600981701',
        'description': 'Chilli-Chutney flavour uses base spices of ground coriander seeds, salt and pepper mixed with worcester sauce and malt vinegar, with added chilli chutney for that awesome sweet and spicy taste.',
      },
      {
        'title': 'Garlic',
        'product_id': 1749090762850,
        'variant_id': 16299985797218,
        'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/flavour-full_garlic.png?v=1600981700',
        'description': 'Garlic flavour uses base spices of ground coriander seeds, salt and pepper mixed with worcester sauce and malt vinegar mixed with garlic salts.',
      },
      {
        'title': 'Original Drywors',
        'product_id': 1749040660578,
        'variant_id': 16299561484386,
        'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/flavour-full_original_drywors.png?v=1600981700',
        'description': 'Using quality ingredients (extra lean beef) mixed with authentic coriander ground spice, salt, pepper. Nothing more.',
      },
      {
        'title': 'GO m-eat!',
        'product_id': 1749097447522,
        'variant_id': 16300052283490,
        'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/flavour-full_go_m-eat.png?v=1600983706',
        'description': 'This high protein biltong snack is full of flavour yet low in sugar, lean and low in carbs.',
      }
    ]
  },
    {
      'title': 'Build Your Box',
      'product_id': 6180082057408, 
      'variant_id': 38032201777344, 
      'box_size': 0,
      'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/Box_5.jpg?v=1601045178',
      'size': 0,
      'price': 10.58,
      'flavours': [
        {
          'title': 'The Original',
          'product_id': 1749088108642,
          'variant_id': 16299959812194,
          'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/flavour-full_the_original.png?v=1600981700',
          'description': 'Original flavour uses base spices of ground coriander seeds, salt and pepper mixed with worcester sauce and malt vinegar.',
        },
        {
          'title': 'Wild Venison',
          'product_id': 6584060248256,
          'variant_id': 39431284195520,
          'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/venison_singl.png?v=1627336837',
          'description': 'Try our new pasture-fed, super lean, super wild, super tasty venison biltong',
        },
        {
          'title': 'Peri Peri',
          'product_id': 1749049475170,
          'variant_id': 16299647008866,
          'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/flavour-full_peri_peri.png?v=1600985731',
          'description': 'Peri-Peri flavour uses base spices of ground coriander seeds, salt and pepper mixed with worcester sauce and malt vinegar, with added peri-peri for that extra kick.',
        },
        {
          'title': 'Chilli Chutney',
          'product_id': 1749094793314,
          'variant_id': 16300022464610,
          'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/flavour-full_chilli_chutney.png?v=1600981701',
          'description': 'Chilli-Chutney flavour uses base spices of ground coriander seeds, salt and pepper mixed with worcester sauce and malt vinegar, with added chilli chutney for that awesome sweet and spicy taste.',
        },
        {
          'title': 'Garlic',
          'product_id': 1749090762850,
          'variant_id': 16299985797218,
          'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/flavour-full_garlic.png?v=1600981700',
          'description': 'Garlic flavour uses base spices of ground coriander seeds, salt and pepper mixed with worcester sauce and malt vinegar mixed with garlic salts.',
        },
        {
          'title': 'Original Drywors',
          'product_id': 1749040660578,
          'variant_id': 16299561484386,
          'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/flavour-full_original_drywors.png?v=1600981700',
          'description': 'Using quality ingredients (extra lean beef) mixed with authentic coriander ground spice, salt, pepper. Nothing more.',
        },
        {
          'title': 'GO m-eat!',
          'product_id': 1749097447522,
          'variant_id': 16300052283490,
          'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/flavour-full_go_m-eat.png?v=1600983706',
          'description': 'This high protein biltong snack is full of flavour yet low in sugar, lean and low in carbs.',
        }
      ]
    },
    {
      'title': 'The Snack Selection Box (8 x 35g bags)',
      'product_id': 6585265946816, //need to change
      'variant_id': 39431296024768, //need to change
      'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/8_x_35.jpg?v=1616677347',
      'size': 8,
      'price': 16.99,
      'flavours': [
        {
          'title': 'Cracked Pepper',
          'product_id': 6792177254592,
          'variant_id': 40297881567424,
          'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/cp.png?v=1627298119',
          'description': "Wonderfully peppery biltong made according to our signature recipe and air-dried to perfection.",
        },
        {
          'title': 'BBQ',
          'product_id': 6183000735936,
          'variant_id': 38046939578560,
          'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/flavour-full_bbq.png?v=1613066473',
          'description': "Our brand new flavour! It's smokey, it's spicy, it's perfect.",
        },
        {
          'title': 'Wild Venison',
          'product_id': 6584060248256,
          'variant_id': 39431284195520,
          'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/venison_singl.png?v=1627336837',
          'description': 'Try our new pasture-fed, super lean, super wild, super tasty venison biltong',
        },
        {
          'title': 'The Original',
          'product_id': 1749088108642,
          'variant_id': 16299959812194,
          'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/flavour-full_the_original.png?v=1600981700',
          'description': 'Original flavour uses base spices of ground coriander seeds, salt and pepper mixed with worcester sauce and malt vinegar.',
        },
        {
          'title': 'Peri Peri',
          'product_id': 1749049475170,
          'variant_id': 16299647008866,
          'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/flavour-full_peri_peri.png?v=1600985731',
          'description': 'Peri-Peri flavour uses base spices of ground coriander seeds, salt and pepper mixed with worcester sauce and malt vinegar, with added peri-peri for that extra kick.',
        },
        {
          'title': 'Chilli Chutney',
          'product_id': 1749094793314,
          'variant_id': 16300022464610,
          'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/flavour-full_chilli_chutney.png?v=1600981701',
          'description': 'Chilli-Chutney flavour uses base spices of ground coriander seeds, salt and pepper mixed with worcester sauce and malt vinegar, with added chilli chutney for that awesome sweet and spicy taste.',
        },
        {
          'title': 'Garlic',
          'product_id': 1749090762850,
          'variant_id': 16299985797218,
          'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/flavour-full_garlic.png?v=1600981700',
          'description': 'Garlic flavour uses base spices of ground coriander seeds, salt and pepper mixed with worcester sauce and malt vinegar mixed with garlic salts.',
        },
        {
          'title': 'Original Drywors',
          'product_id': 1749040660578,
          'variant_id': 16299561484386,
          'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/flavour-full_original_drywors.png?v=1600981700',
          'description': 'Using quality ingredients (extra lean beef) mixed with authentic coriander ground spice, salt, pepper. Nothing more.',
        },
        {
          'title': 'GO m-eat!',
          'product_id': 1749097447522,
          'variant_id': 16300052283490,
          'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/flavour-full_go_m-eat.png?v=1600983706',
          'description': 'This high protein biltong snack is full of flavour yet low in sugar, lean and low in carbs.',
        }
      ]
    },
    {
      'title': 'The Protein Box Subscription (8 x 35g bags)',
      'product_id': 14628749476218, //need to change
      'variant_id': 51661716652410, //need to change
      'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/8_x_35.jpg?v=1616677347',
      'size': 8,
      'price': 16.99,
      'flavours': [
        {
          'title': 'Cracked Pepper',
          'product_id': 6792177254592,
          'variant_id': 40297881567424,
          'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/cp.png?v=1627298119',
          'description': "Wonderfully peppery biltong made according to our signature recipe and air-dried to perfection.",
        },
        {
          'title': 'BBQ',
          'product_id': 6183000735936,
          'variant_id': 38046939578560,
          'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/flavour-full_bbq.png?v=1613066473',
          'description': "Our brand new flavour! It's smokey, it's spicy, it's perfect.",
        },
        {
          'title': 'Wild Venison',
          'product_id': 6584060248256,
          'variant_id': 39431284195520,
          'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/venison_singl.png?v=1627336837',
          'description': 'Try our new pasture-fed, super lean, super wild, super tasty venison biltong',
        },
        {
          'title': 'The Original',
          'product_id': 1749088108642,
          'variant_id': 16299959812194,
          'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/flavour-full_the_original.png?v=1600981700',
          'description': 'Original flavour uses base spices of ground coriander seeds, salt and pepper mixed with worcester sauce and malt vinegar.',
        },
        {
          'title': 'Peri Peri',
          'product_id': 1749049475170,
          'variant_id': 16299647008866,
          'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/flavour-full_peri_peri.png?v=1600985731',
          'description': 'Peri-Peri flavour uses base spices of ground coriander seeds, salt and pepper mixed with worcester sauce and malt vinegar, with added peri-peri for that extra kick.',
        },
        {
          'title': 'Chilli Chutney',
          'product_id': 1749094793314,
          'variant_id': 16300022464610,
          'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/flavour-full_chilli_chutney.png?v=1600981701',
          'description': 'Chilli-Chutney flavour uses base spices of ground coriander seeds, salt and pepper mixed with worcester sauce and malt vinegar, with added chilli chutney for that awesome sweet and spicy taste.',
        },
        {
          'title': 'Garlic',
          'product_id': 1749090762850,
          'variant_id': 16299985797218,
          'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/flavour-full_garlic.png?v=1600981700',
          'description': 'Garlic flavour uses base spices of ground coriander seeds, salt and pepper mixed with worcester sauce and malt vinegar mixed with garlic salts.',
        },
        {
          'title': 'Original Drywors',
          'product_id': 1749040660578,
          'variant_id': 16299561484386,
          'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/flavour-full_original_drywors.png?v=1600981700',
          'description': 'Using quality ingredients (extra lean beef) mixed with authentic coriander ground spice, salt, pepper. Nothing more.',
        },
        {
          'title': 'GO m-eat!',
          'product_id': 1749097447522,
          'variant_id': 16300052283490,
          'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/flavour-full_go_m-eat.png?v=1600983706',
          'description': 'This high protein biltong snack is full of flavour yet low in sugar, lean and low in carbs.',
        }
      ]
    },
    {
      'title': 'The Snack Selection Box (5 x 35g bags)',
      'product_id': 1849469075554, //need to change
      'variant_id': 31953604673634, //need to change
      'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/Box_5.jpg?v=1601045178',
      'size': 5,
      'price': 12.00,
      'flavours': [
        {
          'title': 'Cracked Pepper',
          'product_id': 6792177254592,
          'variant_id': 40297881567424,
          'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/cp.png?v=1627298119',
          'description': "Wonderfully peppery biltong made according to our signature recipe and air-dried to perfection.",
        },
        {
          'title': 'BBQ',
          'product_id': 6183000735936,
          'variant_id': 38046939578560,
          'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/flavour-full_bbq.png?v=1613066473',
          'description': "Our brand new flavour! It's smokey, it's spicy, it's perfect.",
        },
        {
          'title': 'Wild Venison',
          'product_id': 6584060248256,
          'variant_id': 39431284195520,
          'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/venison_singl.png?v=1627336837',
          'description': 'Try our new pasture-fed, super lean, super wild, super tasty venison biltong',
        },
        {
          'title': 'The Original',
          'product_id': 1749088108642,
          'variant_id': 16299959812194,
          'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/flavour-full_the_original.png?v=1600981700',
          'description': 'Original flavour uses base spices of ground coriander seeds, salt and pepper mixed with worcester sauce and malt vinegar.',
        },
        {
          'title': 'Peri Peri',
          'product_id': 1749049475170,
          'variant_id': 16299647008866,
          'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/flavour-full_peri_peri.png?v=1600985731',
          'description': 'Peri-Peri flavour uses base spices of ground coriander seeds, salt and pepper mixed with worcester sauce and malt vinegar, with added peri-peri for that extra kick.',
        },
        {
          'title': 'Chilli Chutney',
          'product_id': 1749094793314,
          'variant_id': 16300022464610,
          'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/flavour-full_chilli_chutney.png?v=1600981701',
          'description': 'Chilli-Chutney flavour uses base spices of ground coriander seeds, salt and pepper mixed with worcester sauce and malt vinegar, with added chilli chutney for that awesome sweet and spicy taste.',
        },
        {
          'title': 'Garlic',
          'product_id': 1749090762850,
          'variant_id': 16299985797218,
          'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/flavour-full_garlic.png?v=1600981700',
          'description': 'Garlic flavour uses base spices of ground coriander seeds, salt and pepper mixed with worcester sauce and malt vinegar mixed with garlic salts.',
        },
        {
          'title': 'Original Drywors',
          'product_id': 1749040660578,
          'variant_id': 16299561484386,
          'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/flavour-full_original_drywors.png?v=1600981700',
          'description': 'Using quality ingredients (extra lean beef) mixed with authentic coriander ground spice, salt, pepper. Nothing more.',
        },
        {
          'title': 'GO m-eat!',
          'product_id': 1749097447522,
          'variant_id': 16300052283490,
          'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/flavour-full_go_m-eat.png?v=1600983706',
          'description': 'This high protein biltong snack is full of flavour yet low in sugar, lean and low in carbs.',
        }
      ]
    },
    {
      'title': 'The Snack Selection Box (4 x 35g bags)',
      'product_id': 1849469075554,
      'variant_id': 17493351563362,
      'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/Box_4.jpg?v=1600957995',
      'size': 4,
      'price': 8.46,
      'flavours': [
        {
          'title': 'Cracked Pepper',
          'product_id': 6792177254592,
          'variant_id': 40297881567424,
          'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/cp.png?v=1627298119',
          'description': "Wonderfully peppery biltong made according to our signature recipe and air-dried to perfection.",
        },
        {
          'title': 'BBQ',
          'product_id': 6183000735936,
          'variant_id': 38046939578560,
          'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/flavour-full_bbq.png?v=1613066473',
          'description': "Our brand new flavour! It's smokey, it's spicy, it's perfect.",
        },
        {
          'title': 'Wild Venison',
          'product_id': 6584060248256,
          'variant_id': 39431284195520,
          'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/venison_singl.png?v=1627336837',
          'description': 'Try our new pasture-fed, super lean, super wild, super tasty venison biltong',
        },
        {
          'title': 'The Original',
          'product_id': 1749088108642,
          'variant_id': 16299959812194,
          'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/flavour-full_the_original.png?v=1600981700',
          'description': 'Original flavour uses base spices of ground coriander seeds, salt and pepper mixed with worcester sauce and malt vinegar.',
        },
        {
          'title': 'Peri Peri',
          'product_id': 1749049475170,
          'variant_id': 16299647008866,
          'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/flavour-full_peri_peri.png?v=1600985731',
          'description': 'Peri-Peri flavour uses base spices of ground coriander seeds, salt and pepper mixed with worcester sauce and malt vinegar, with added peri-peri for that extra kick.',
        },
        {
          'title': 'Chilli Chutney',
          'product_id': 1749094793314,
          'variant_id': 16300022464610,
          'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/flavour-full_chilli_chutney.png?v=1600981701',
          'description': 'Chilli-Chutney flavour uses base spices of ground coriander seeds, salt and pepper mixed with worcester sauce and malt vinegar, with added chilli chutney for that awesome sweet and spicy taste.',
        },
        {
          'title': 'Garlic',
          'product_id': 1749090762850,
          'variant_id': 16299985797218,
          'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/flavour-full_garlic.png?v=1600981700',
          'description': 'Garlic flavour uses base spices of ground coriander seeds, salt and pepper mixed with worcester sauce and malt vinegar mixed with garlic salts.',
        },
        {
          'title': 'Original Drywors',
          'product_id': 1749040660578,
          'variant_id': 16299561484386,
          'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/flavour-full_original_drywors.png?v=1600981700',
          'description': 'Using quality ingredients (extra lean beef) mixed with authentic coriander ground spice, salt, pepper. Nothing more.',
        },
        {
          'title': 'GO m-eat!',
          'product_id': 1749097447522,
          'variant_id': 16300052283490,
          'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/flavour-full_go_m-eat.png?v=1600983706',
          'description': 'This high protein biltong snack is full of flavour yet low in sugar, lean and low in carbs.',
        }
      ]
    },
    {
      'title': 'The Classic Box (6 x 75g bags)',
      'product_id': 6585193038016,
      'variant_id': 39435581030592,
      'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/6_of_75g.jpg?v=1616677360',
      'size': 6,
      'price': 27.90,
      'flavours': [
        {
          'title': 'Cracked Pepper',
          'product_id': 6792177254592,
          'variant_id': 40297881600192,
          'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/cp.png?v=1627298119',
          'description': "Wonderfully peppery biltong made according to our signature recipe and air-dried to perfection.",
        },
        {
          'title': 'BBQ',
          'product_id': 6183000735936,
          'variant_id': 38046939611328,
          'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/flavour-full_bbq.png?v=1613066473',
          'description': "Our brand new flavour! It's smokey, it's spicy, it's perfect.",
        },
        {
          'title': 'Wild Venison',
          'product_id': 6584060248256,
          'variant_id': 39431284228288,
          'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/venison_singl.png?v=1627336837',
          'description': 'Try our new pasture-fed, super lean, super wild, super tasty venison biltong',
        },
        {
          'title':'The Original',
          'product_id': 1749088108642,
          'variant_id': 17493038923874,
          'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/flavour-full_the_original.png?v=1600981700',
          'description':'Original flavour uses base spices of ground coriander seeds, salt and pepper mixed with worcester sauce and malt vinegar.',
        },
        {
          'title': 'Peri Peri',
          'product_id': 1749049475170,
          'variant_id': 17493088895074,
          'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/flavour-full_peri_peri.png?v=1600985731',
          'description': 'Peri-Peri flavour uses base spices of ground coriander seeds, salt and pepper mixed with worcester sauce and malt vinegar, with added peri-peri for that extra kick.',
        },
        {
          'title': 'Chilli Chutney',
          'product_id': 1749094793314,
          'variant_id': 17493180448866,
          'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/flavour-full_chilli_chutney.png?v=1600981701',
          'description': 'Chilli-Chutney flavour uses base spices of ground coriander seeds, salt and pepper mixed with worcester sauce and malt vinegar, with added chilli chutney for that awesome sweet and spicy taste.',
        },
        {
          'title': 'Garlic',
          'product_id': 1749090762850,
          'variant_id': 17493223014498,
          'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/flavour-full_garlic.png?v=1600981700',
          'description': 'Garlic flavour uses base spices of ground coriander seeds, salt and pepper mixed with worcester sauce and malt vinegar mixed with garlic salts.',
        },
        {
          'title': 'Original Drywors',
          'product_id': 1749040660578,
          'variant_id': 17493241036898,
          'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/flavour-full_original_drywors.png?v=1600981700',
          'description': 'Using quality ingredients (extra lean beef) mixed with authentic coriander ground spice, salt, pepper. Nothing more.',
        },
        {
          'title': 'GO m-eat!',
          'product_id': 1749097447522,
          'variant_id': 17493157118050,
          'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/flavour-full_go_m-eat.png?v=1600983706',
          'description': 'This high protein biltong snack is full of flavour yet low in sugar, lean and low in carbs.',
        }
      ]
    },
    {
      'title': 'The Classic Box (3 x 75g bags)',
      'product_id': 1849469075554,
      'variant_id': 17493351530594,
      'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/Box_3_3dd311af-1f4f-4aa6-8b64-78887967a617.jpg?v=1600982575',
      'size': 3,
      'price': 12.29,
      'flavours': [
        {
          'title': 'Cracked Pepper',
          'product_id': 6792177254592,
          'variant_id': 40297881600192,
          'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/cp.png?v=1627298119',
          'description': "Wonderfully peppery biltong made according to our signature recipe and air-dried to perfection.",
        },
        {
          'title': 'BBQ',
          'product_id': 6183000735936,
          'variant_id': 38046939611328,
          'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/flavour-full_bbq.png?v=1613066473',
          'description': "Our brand new flavour! It's smokey, it's spicy, it's perfect.",
        },
        {
          'title': 'Wild Venison',
          'product_id': 6584060248256,
          'variant_id': 39431284228288,
          'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/venison_singl.png?v=1627336837',
          'description': 'Try our new pasture-fed, super lean, super wild, super tasty venison biltong',
        },
        {
          'title':'The Original',
          'product_id': 1749088108642,
          'variant_id': 17493038923874,
          'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/flavour-full_the_original.png?v=1600981700',
          'description':'Original flavour uses base spices of ground coriander seeds, salt and pepper mixed with worcester sauce and malt vinegar.',
        },
        {
          'title': 'Peri Peri',
          'product_id': 1749049475170,
          'variant_id': 17493088895074,
          'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/flavour-full_peri_peri.png?v=1600985731',
          'description': 'Peri-Peri flavour uses base spices of ground coriander seeds, salt and pepper mixed with worcester sauce and malt vinegar, with added peri-peri for that extra kick.',
        },
        {
          'title': 'Chilli Chutney',
          'product_id': 1749094793314,
          'variant_id': 17493180448866,
          'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/flavour-full_chilli_chutney.png?v=1600981701',
          'description': 'Chilli-Chutney flavour uses base spices of ground coriander seeds, salt and pepper mixed with worcester sauce and malt vinegar, with added chilli chutney for that awesome sweet and spicy taste.',
        },
        {
          'title': 'Garlic',
          'product_id': 1749090762850,
          'variant_id': 17493223014498,
          'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/flavour-full_garlic.png?v=1600981700',
          'description': 'Garlic flavour uses base spices of ground coriander seeds, salt and pepper mixed with worcester sauce and malt vinegar mixed with garlic salts.',
        },
        {
          'title': 'Original Drywors',
          'product_id': 1749040660578,
          'variant_id': 17493241036898,
          'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/flavour-full_original_drywors.png?v=1600981700',
          'description': 'Using quality ingredients (extra lean beef) mixed with authentic coriander ground spice, salt, pepper. Nothing more.',
        },
        { 
          'title': 'GO m-eat!',
          'product_id': 1749097447522,
          'variant_id': 17493157118050,
          'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/flavour-full_go_m-eat.png?v=1600983706',
          'description': 'This high protein biltong snack is full of flavour yet low in sugar, lean and low in carbs.',
        }
      ]
    },
    {
      'title': 'The Classic Box (4 x 75g bags)',
      'product_id': 1849469075554,
      'variant_id': 31953605034082,
      'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/Box_3_3dd311af-1f4f-4aa6-8b64-78887967a617.jpg?v=1600982575',
      'size': 4,
      'price': 18.60,
      'flavours': [
        {
          'title': 'Cracked Pepper',
          'product_id': 6792177254592,
          'variant_id': 40297881600192,
          'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/cp.png?v=1627298119',
          'description': "Wonderfully peppery biltong made according to our signature recipe and air-dried to perfection.",
        },
        {
          'title': 'BBQ',
          'product_id': 6183000735936,
          'variant_id': 38046939611328,
          'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/flavour-full_bbq.png?v=1613066473',
          'description': "Our brand new flavour! It's smokey, it's spicy, it's perfect.",
        },
        {
          'title': 'Wild Venison',
          'product_id': 6584060248256,
          'variant_id': 39431284228288,
          'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/v_pack.png?v=1618177381',
          'description': 'Try our new pasture-fed, super lean, super wild, super tasty venison biltong',
        },
        {
          'title':'The Original',
          'product_id': 1749088108642,
          'variant_id': 17493038923874,
          'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/flavour-full_the_original.png?v=1600981700',
          'description':'Original flavour uses base spices of ground coriander seeds, salt and pepper mixed with worcester sauce and malt vinegar.',
        },
        {
          'title': 'Peri Peri',
          'product_id': 1749049475170,
          'variant_id': 17493088895074,
          'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/flavour-full_peri_peri.png?v=1600985731',
          'description': 'Peri-Peri flavour uses base spices of ground coriander seeds, salt and pepper mixed with worcester sauce and malt vinegar, with added peri-peri for that extra kick.',
        },
        {
          'title': 'Chilli Chutney',
          'product_id': 1749094793314,
          'variant_id': 17493180448866,
          'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/flavour-full_chilli_chutney.png?v=1600981701',
          'description': 'Chilli-Chutney flavour uses base spices of ground coriander seeds, salt and pepper mixed with worcester sauce and malt vinegar, with added chilli chutney for that awesome sweet and spicy taste.',
        },
        {
          'title': 'Garlic',
          'product_id': 1749090762850,
          'variant_id': 17493223014498,
          'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/flavour-full_garlic.png?v=1600981700',
          'description': 'Garlic flavour uses base spices of ground coriander seeds, salt and pepper mixed with worcester sauce and malt vinegar mixed with garlic salts.',
        },
        {
          'title': 'Original Drywors',
          'product_id': 1749040660578,
          'variant_id': 17493241036898,
          'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/flavour-full_original_drywors.png?v=1600981700',
          'description': 'Using quality ingredients (extra lean beef) mixed with authentic coriander ground spice, salt, pepper. Nothing more.',
        },
        {
          'title': 'GO m-eat!',
          'product_id': 1749097447522,
          'variant_id': 17493157118050,
          'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/flavour-full_go_m-eat.png?v=1600983706',
          'description': 'This high protein biltong snack is full of flavour yet low in sugar, lean and low in carbs.',
        }
      ]
    },
    {
      'title': 'The Big Sharing Box (1 x 250g bag)',
      'product_id': 1849469075554,
      'variant_id': 17493351465058,
      'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/box_1.jpg?v=1600957964',
      'size': 1,
      'price': 16.00,
      'flavours': [
        {
          'title': 'The Original',
          'product_id': 1749088108642,
          'variant_id': 17493038956642,
          'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/flavour-full_the_original.png?v=1600981700',
          'description': 'Original flavour uses base spices of ground coriander seeds, salt and pepper mixed with worcester sauce and malt vinegar.',
        },
        {
          'title': 'Peri Peri',
          'product_id': 1749049475170,
          'variant_id': 17493088927842,
          'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/flavour-full_peri_peri.png?v=1600985731',
          'description': 'Peri-Peri flavour uses base spices of ground coriander seeds, salt and pepper mixed with worcester sauce and malt vinegar, with added peri-peri for that extra kick.',
        },
        {
          'title': 'Chilli Chutney',
          'product_id': 1749094793314,
          'variant_id': 17493180481634,
          'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/flavour-full_chilli_chutney.png?v=1600981701',
          'description': 'Chilli-Chutney flavour uses base spices of ground coriander seeds, salt and pepper mixed with worcester sauce and malt vinegar, with added chilli chutney for that awesome sweet and spicy taste.',
        },
        {
          'title': 'Original Drywors',
          'product_id': 1749040660578,
          'variant_id': 17493241069666,
          'image': 'https://cdn.shopify.com/s/files/1/0063/8133/8722/files/flavour-full_original_drywors.png?v=1600981701',
          'description': 'Using quality ingredients (extra lean beef) mixed with authentic coriander ground spice, salt, pepper. Nothing more.',
        }
      ]
    },
  ]
/*
* --------------------- Variables and Functioms ---------------------
*/

// Server URL's 
//const server_url = 'https://cors-anywhere.herokuapp.com/https://m-eat-recharge-dev.herokuapp.com'   // Dev Mode
const server_url = 'https://cors-anywhere.herokuapp.com/https://m-eat-recharge-api.herokuapp.com'     // Production Mode

// Fetch Current Flavours for each Subscription
function fetch_current_flavours(id, position, element) {
  $.ajax({
    type: 'GET',
    url: server_url + '/api/v1/recharge/subscriptions.json',
    dataType: 'json',
    data: { subscription_id: id },
    success: function (data) {
      data = $.parseJSON(data);
      //console.log(data);     // Output the data object to see what data is available

      // Set variables
      current_flavours = '';
      flavour_number = 0;
      //console.log(data.subscription);     // Output the data object to see what data is available

      $.each(data.subscription.properties, function (index, property) {
        if (property.name.indexOf('flavour') > -1 && property.name.indexOf('variant_id') <= -1) {
          flavour_number = (flavour_number + 1);
          current_flavours = current_flavours + '<li><strong>Flavour ' + flavour_number + ':</strong> ' + property.value + '</li>';
        }
      });
      let current_flavour_list = '<ul>' + current_flavours + '</ul>';
      switch (position) {
        case 'append':
          $(element).append(current_flavour_list);
          break;
        case 'prepend':
          $(element).prepend(current_flavour_list);
          break;
        case 'insertAfter':
          $(current_flavour_list).insertAfter(element);
          break;
        case 'insertBefore':
          $(current_flavour_list).insertBefore(element);
          break;
        default:
          $(element).append(current_flavour_list);
      }
    },
    error: function (data) {
    }
  });
}

// Set Custom Swap Data Attributes (Flavours and ID's)
function custom_swap_data_attributes(id, swap_button) {
  $.ajax({
    type: 'POST',
    url: server_url + '/api/v1/recharge/subscriptions.json',
    dataType: 'json',
    data: { subscription_id: id },
    success: function (data) {
      data = $.parseJSON(data);
      //console.log(data);     // Output the data object to see what data is available

      // Set data variables
      box_variant_id = data.subscription.shopify_variant_id;
      current_flavours_array = [];
      $.each(data.subscription.properties, function (index, property) {
        if (property.name.indexOf('variant_id') > -1) {
          current_flavours_array.push(property.value);
        }
      });
      $(swap_button).attr('data-variant-id', box_variant_id);
      $(swap_button).attr('data-flavours', current_flavours_array);
    },
    error: function (data) {
    }
  });
}

// Set Custom Swap Data Attributes
function get_current_box(id) {
  $.ajax({
    type: 'GET',
    url: server_url + '/api/v1/recharge/subscriptions.json',
    dataType: 'json',
    data: { subscription_id: id },
    success: function (data) {
      data = $.parseJSON(data);
      //console.log(data);     // Output the data object to see what data is available

      $('#Change-ReCharge-variant').removeClass('disabled').removeClass('loader').addClass('enabled').text('Change your m-eat! box');

      const current_properties = data.subscription.properties;
      var current_flavours = '';
      var flavour_number = 0;
      $.each(current_properties, function (index, property) {
        if (property.name.indexOf('flavour') > -1 && property.name.indexOf('variant_id') <= -1) {
          flavour_number = (flavour_number + 1);
          current_flavours += '<li><strong>Flavour ' + flavour_number + ':</strong> ' + property.value + '</li>';
        }
      });

      let available_box = ''; 
      const current_id = data.subscription.shopify_variant_id;
      for (var i = 0; i < boxes_and_flavours.length; i++) {
        const box_id = boxes_and_flavours[i].variant_id;
        const box_title = boxes_and_flavours[i].title;
        const box_image = boxes_and_flavours[i].image;
        const box_price = boxes_and_flavours[i].price;
        if (boxes_and_flavours[i].variant_id == current_id) {
          var current_box = '<li class="box current_box" data-available-box-variant-id="'+box_id+'" data-available-box-price="'+box_price+'" data-available-box-title="'+box_title+'"><img src="'+box_image+'" alt="'+box_title+'" class="lazyload" width="150" /><span class="info"><h4>'+box_title+'</h4><ul class="current_flavours"></ul></span></li>';
        } 
        else if( boxes_and_flavours[i].variant_id == 17493351563362 || boxes_and_flavours[i].variant_id == 17493351530594 ){
          //doesn't display
        }
        else {
          available_box += '<li class="box available_box" data-available-box-variant-id="'+box_id+'" data-available-box-price="'+box_price+'" data-available-box-title="'+box_title+'"><img src="'+box_image+'" alt="'+box_title+'" class="lazyload" width="150" /><span class="info"><h4>'+box_title+'</h4><p class="price">Subscribe and Save: &pound;'+box_price+'</p></span></li>';
        }
      }

      $('#change_box .content #current_box .current_box').append(current_box);
      $('#change_box .content #current_box .current_flavours').append(current_flavours);
      $('#change_box .content #available_boxes .available_boxes').append(available_box);
    },
    error: function (data) {
    }
  });
}

// Set up basic modal to append to body
let change_flavour_modal = '<div class="modal micromodal-slide" id="change_flavour" aria-hidden="true"><div class="modal__overlay" tabindex="-1" data-custom-close="change_flavour"><div class="modal__container" role="dialog" aria-modal="true" aria-labelledby="subscription-title"><div class="header"><h3></h3></div><div class="content"><div id="flavours"></div><div id="change_flavour_button"><span class="cancel" data-custom-close="change_flavour">Cancel</span><span class="change_flavour disabled">No flavours have been swapped</span></div></div></div></div>'

// Clear content before opening modal
function change_flavour_modal_reset() {
  $('#change_flavour .header h3').html('');
  $('#change_flavour .content #flavours').html('');
  $('#change_flavour_button').attr('data-subscription-id', '')
  $('#change_flavour_button .change_flavour').attr('data-subscription-id', '').attr('data-current-flavours', '').removeClass('enabled').addClass('disabled').text('No flavours have been swapped');
}

// Compare two arrays
function compareArrays(array1, array2) {
  if (array1 instanceof Array && array2 instanceof Array) {
      return array1.length === array2.length && array1.every((v, i) => v === array2[i]);
  }
  return array1 === array2;
}

// Set new flavours and compare the arrays to see they are the same or not.
function set_new_flavours() {
  const new_flavours = [];
  $('#change_flavour .flavour select option:selected').each(function () {
    new_flavour_varinat_id = $(this).attr('value');
    current_flavours = $('#change_flavour_button .change_flavour').attr('data-current-flavours').split(',');
    new_flavours.push(new_flavour_varinat_id);
  });
  if (!compareArrays(current_flavours, new_flavours)) {
    $('#change_flavour_button .change_flavour').removeClass('disabled').addClass('enabled').html('Yes, I want to try these new delicious flavours in my next box!')
  } else {
    $('#change_flavour_button .change_flavour').addClass('disabled').removeClass('enabled').html('No flavours have been swapped')
  }
}

// Reload flavours for the box that just changed
function reload_flavours_after_swap(subscription_id) {
  // Fetch Current Flavours and append flavour list to product title
  $('.product-' + subscription_id + ' .rc_subscriptions__subscription__item__product .bt-content ul').remove();
  const element = '.product-' + subscription_id + ' .rc_subscriptions__subscription__item__product .bt-content p:first-child';
  fetch_current_flavours(subscription_id, 'insertAfter', element);

  // Set custom swap data attributes
  const custom_swap_button = '.product-' + subscription_id + ' .custom-swap a';
  custom_swap_data_attributes(subscription_id, custom_swap_button);

  $('body').prepend(change_flavour_modal);
}

// Post new flavours to Recharge
function recharge_change_flavours(subscription_id, new_properties, new_flavours) {
  $.ajax({
    type: 'POST',
    url: server_url + '/api/v1/recharge/swap_flavours.json',
    dataType: 'json',
    data: { properties: JSON.stringify(new_properties), subscription_id: subscription_id },
    success: function (data) {
      $('#change_flavour.modal .header h3').empty().text('Flavours Swapped!')
      $('#change_flavour.modal .content #flavours').empty().html('<p>Your box has now been updated with these new flavours:</p><ul id="new_flavours">' + new_flavours + '</ul>')
      $('#change_flavour_button').empty().html('<span class="modal_close" data-custom-close="change_flavour">Close</span>');

      var subscription_id = $('#change_flavour_button').attr('data-subscription-id');
      reload_flavours_after_swap(subscription_id);
    },
    error: function (data) {
    }
  });
}

// Post new flavours to Recharge
function recharge_change_product_and_flavour(subscription_id, new_product) {
  $.ajax({
    type: 'POST',
    //url: server_url + '/api/v1/recharge/swap_product_and_flav.json',
    url: server_url + '/api/v1/recharge/swap_product.json',
    dataType: 'json',
    data: { new_product, subscription_id: subscription_id },
    success: function (data) {
      data = JSON.stringify(data);
      window.location.replace('?box_changed=true');
    },
    error: function (data) {
    }
  });
}

// Reset Step 1 and 2 CSS
function go_back_or_close(){
  $('#step1').animate({'top':'0','z-index':'0'}, 100);
  $('#step2').animate({'top':'-999px','z-index':'-1'}, 100);

  $('#step1').css('position','relative');
  $('#step2').css('position','absolute');

  $('#step2 .flavour_selection').html('');

  setTimeout(function() {
    $(".modal__container").animate({ scrollTop: 0 }, 300);
  }, 300);
}

//Get param from URL
function getParameterByName(name, url) {
	if (!url) url = window.location.href;
	name = name.replace(/[\[\]]/g, '\\$&');
	var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
			results = regex.exec(url);
	if (!results) return null;
	if (!results[2]) return '';
	return decodeURIComponent(results[2].replace(/\+/g, ' '));
}


/*
* --------------------- Current Plans ---------------------
*/
function current_plans() {
  $('.rc_subscriptions__subscription').each(function (index) {
    // Get Selector
    const plan_number_index = index + 1;
    const plan_number = '.rc_subscriptions__subscription__' + plan_number_index;

    // Edited current subscriptions to add the edit link along with some wording above the address
    $(plan_number + ' .purchase-address').prepend('<p class="shipping">Delivery Address</p>');
    $(plan_number + ' .shipping').append($(plan_number + ' .rc_subscriptions__subscription__address__edit'));

    // Replace Swap for Custom Swap feature
    $(plan_number + ' .rc_subscriptions__subscription__item__actions span.bt-content div').hide().after('<div class="custom-swap"><a href="#" >Swap current flavours</a></div>')
    $(plan_number + ' .rc_subscriptions__subscription__item__actions span.bt-content #rc_subscriptions__subscription__item__swap').remove();

    // Product Name
    let product_name = $(plan_number + ' .rc_subscriptions__subscription__item .rc_subscriptions__subscription__item__product p:first-child');
    $(product_name).each(function () {
      let product_title = $(this).html().trim().replace('Biltong Box', '').replace('  (Auto renew)', '').replace(' - ', '');
      product_title = product_title.split(' (');
      const product = product_title[0] + '<br />(' + product_title[1];
      $(this).html(product);
    });

    // Set custom data
    let get_plan_number_for_id = $(plan_number + ' .rc_subscriptions__subscription__item');
    $(get_plan_number_for_id).each(function (index) {

      // Get Plan ID 
      const plan_number_for_id = $(this).attr('class');
      const plan_id = parseInt(plan_number_for_id.split('product-')[1].split(' ')[0]);

      // Fetch Current Flavours and append flavour list to product title
      const element = plan_number + ' .product-' + plan_id + ' .rc_subscriptions__subscription__item__product .bt-content p:first-child';
      fetch_current_flavours(plan_id, 'insertAfter', element);

      // Set custom swap data attributes
      const custom_swap_button = plan_number + ' .product-' + plan_id + ' .custom-swap a';
      custom_swap_data_attributes(plan_id, custom_swap_button);

      // Modal pop up for swapping flavours
      $('body').delegate(plan_number + ' .product-' + plan_id + ' .custom-swap a', 'click', function (e) {
        e.preventDefault();

        // Modal title
        let modal_title = $(plan_number + ' .product-' + plan_id + ' .rc_subscriptions__subscription__item__product p:first-child').html();
        $('#change_flavour .header h3').html(modal_title);

        // Modal content
        // Create Option to add to Select dropdowns
        const variant_id = $(this).attr('data-variant-id');
        let select_option = '';
        let box_variant_ids = [];
        for (var j = 0; j < boxes_and_flavours.length; j++) {
          box_variant_ids.push(boxes_and_flavours[j].variant_id);
          if (boxes_and_flavours[j].variant_id == variant_id) {
            for (var k = 0; k < boxes_and_flavours[j].flavours.length; k++) {
              var flavour_id = boxes_and_flavours[j].flavours[k].variant_id;
              var flavour_product_id = boxes_and_flavours[j].flavours[k].product_id;
              var flavour_title = boxes_and_flavours[j].flavours[k].title;
              select_option += '<option value="' + flavour_id + '" data-product-id="' + flavour_product_id + '">' + flavour_title + '</option>';
            }
          }
        }

        // Create Select to add to HTML
        let flavours_id_array = $(this).attr('data-flavours').split(',');
        let content = '';
        for (var i = 0; i < flavours_id_array.length; i++) {
          flavour_number = i + 1;
          content += '<div id="flavour_' + flavour_number + '" class="flavour"><div class="dropdown"><h4>Flavour ' + flavour_number + '</h4><select id="flavour_dropdown_' + flavour_number + '" name="flavour_' + flavour_number + '">' + select_option + '</select></div><div class="information"><img src="" width="100" /><p class="description"></p></div></div>';
        }

        // Set data to HTML
        $('#change_flavour .content #flavours').prepend(content);

        // Set current flavours to be selected in the dropdown after they have been set
        for (var l = 0; l < flavours_id_array.length; l++) {
          current_flavour = flavours_id_array[l];
          $('#flavour_dropdown_' + (l + 1) + ' option').each(function (index) {
            let option_value = $(this).attr('value');
            if (option_value == current_flavour) {
              $(this).attr('selected', 'selected');
            }
          });
        }

        // Set selected flavour image and description
        $('#change_flavour .content #flavours .flavour').each(function (index) {
          const flavour_id = '#' + $(this).attr('id');
          const selected_flavour_id = $(flavour_id).find('select option:selected').attr('value');
          for (var m = 0; m < boxes_and_flavours.length; m++) {
            if (boxes_and_flavours[m].variant_id == variant_id) {
              for (var n = 0; n < boxes_and_flavours[m].flavours.length; n++) {
                if (boxes_and_flavours[m].flavours[n].variant_id == selected_flavour_id) {
                  $(flavour_id + ' .information img').attr('src', boxes_and_flavours[m].flavours[n].image);
                  $(flavour_id + ' .information p').html(boxes_and_flavours[m].flavours[n].description);
                }
              }
            }
          }
        });

        // Set flavours_id_array as a dtata atrribute to the change flavour button
        $('#change_flavour_button').attr('data-subscription-id', plan_id);
        $('#change_flavour_button .change_flavour').attr('data-subscription-id', plan_id);
        $('#change_flavour_button .change_flavour').attr('data-current-flavours', flavours_id_array);

        // Open Modal with the data set from above
        let modal_name = 'change_flavour';
        window.setTimeout(function () {
          MicroModal.show(modal_name, {
            onShow: function (modal) { }, // [1]
            onClose: function (modal) { change_flavour_modal_reset(); }, // [2]
            closeTrigger: 'data-custom-close', // [4]
            disableScroll: true, // [5]
            disableFocus: false, // [6]
            awaitCloseAnimation: false, // [7]
            debugMode: true // [8]
          })
        }, 100);
      });
    });

    // Add £ sign infront of price
    $(plan_number + ' .rc_subscriptions__subscription__item__price .bt-content').prepend('£');

    // Remove Add Product link on current subscriptions
    $(plan_number + ' p a.rc_button--link.rc_button--primary.rc_button--fa-plus-circle').detach();

    // Remove Discount from deactivated subscriptions
    var plan_status = $(plan_number + ' .rc_subscriptions__subscription__item__date .bt-content').text().toLowerCase().trim();
    if (plan_status.indexOf('cancelled') > -1) {
      $(this).find('.action__showDiscountInput').detach();
    }
  });

  // Set modal data upon built from the data in the loops above;
  $('body').prepend(change_flavour_modal);

  // Change image and description upon selecting a flavour from the dropdown
  $('body').delegate('#change_flavour .flavour select', 'change', function (e) {
    const flavour_id = $(this).val();
    let flavour_dropdown_id = '#' + $(this).parent().parent().attr('id');
    for (var i = 0; i < boxes_and_flavours.length; i++) {
      for (var j = 0; j < boxes_and_flavours[i].flavours.length; j++) {
        if (boxes_and_flavours[i].flavours[j].variant_id == flavour_id) {
          let new_image = boxes_and_flavours[i].flavours[j].image;
          let new_description = boxes_and_flavours[i].flavours[j].description;
          $(flavour_dropdown_id).find('.information img').attr('src', new_image);
          $(flavour_dropdown_id).find('.information .description').html(new_description);
        }
      }
    }
    set_new_flavours();
  });

  // On change flavour click
  $('body').delegate('#change_flavour_button .change_flavour.enabled', 'click', function (e) {
    let subscription_id = $(this).attr('data-subscription-id');
    const new_properties = [];
    const new_flavours_array = [];
    $('#change_flavour .flavour select option:selected').each(function (index) {
      new_properties.push({
        'name': $(this).text(),
        'shopify_product_id': parseInt($(this).attr('data-product-id')),
        'shopify_variant_id': parseInt($(this).val())
      });
      new_flavours_array.push('<li><strong>Flavour ' + (index + 1) + ':</strong> ' + $(this).text() + '</li>')
    });
    let new_flavours = new_flavours_array.join('');
    recharge_change_flavours(subscription_id, new_properties, new_flavours);
    $(this).addClass('loader disabled').removeClass('enabled').text('');
  });

  /*
  * --------------------- Change your m-eat! plan ---------------------
  */
  // Replace text from variant to box
  if(window.location.pathname.indexOf('/tools/recurring/') > -1) {
    if(window.location.pathname.indexOf('/subscriptions/') > -1) {
      var Replacetext = $('#ReCharge-variant').contents().first()[0].textContent;
      $('#ReCharge-variant').contents().first()[0].textContent = Replacetext.replace('variant','box: ');		
    }
  }
  
  // Remove update payment link
  $('#content__customers__subscriptions__items #ReCharge-Payment-Method a').detach();

  // Change box size
  $('#Change-ReCharge-variant').prop('onclick', null).off('click').addClass('disabled').addClass('loader').text('');
  let change_box_modal = '<div class="modal micromodal-slide" id="change_box" aria-hidden="true"><div class="modal__overlay" tabindex="-1" data-custom-close="change_box"><div class="modal__container" role="dialog" aria-modal="true" aria-labelledby="subscription-title"><div class="header"><h3>Change your m-eat! box</h3></div><div class="content"><div id="step1"><div id="current_box"><h4>Current Box</h4><ul class="current_box"></ul></div><div id="available_boxes"><h4>Available Boxes</h4><ul class="available_boxes"></ul></div><div id="change_box_button"><span class="cancel" data-custom-close="change_box">Cancel</span></div></div><div id="step2"><div class="flavour_selection"></div><div class="buttons"><span class="go_back">Go Back</span><span class="confirm enabled">Change Box</span></div></div></div></div></div>';
  $('body').prepend(change_box_modal);

  //Get Subscription ID from URL
  var full_url = window.location.pathname.split('/');
  var selected_subscription_id = full_url[full_url.length-1];

  // Retrieve Subscription
  if(window.location.pathname.indexOf(selected_subscription_id) > -1 && $.isNumeric(selected_subscription_id)) {
    get_current_box(selected_subscription_id);
  }

  // Over-ride recharge button and open up modal
  $('body').delegate('#Change-ReCharge-variant.enabled', 'click', function (e) {
    e.preventDefault();

    // Open Modal with the data set from above
    let modal_name = 'change_box';
    window.setTimeout(function () {
      MicroModal.show(modal_name, {
        onShow: function (modal) { }, // [1]
        onClose: function (modal) {go_back_or_close();}, // [2]
        closeTrigger: 'data-custom-close', // [4]
        disableScroll: true, // [5]
        disableFocus: false, // [6]
        awaitCloseAnimation: false, // [7]
        debugMode: true // [8]
      })
    }, 100);
  });

  // On Available box click
  $('body').delegate('.available_boxes .box', 'click', function (e) {
    // Get box id for clicked box
    let available_box_id = $(this).data('available-box-variant-id');
    let available_box_price = $(this).data('available-box-price');
    let available_box_title = $(this).data('available-box-title');
    
    // Create HTML
    let new_select_option = '';
    let new_flavour_div = '';
    for(var b = 0; b < boxes_and_flavours.length; b++){
      if(boxes_and_flavours[b].variant_id == available_box_id){
        for(var f = 0; f < boxes_and_flavours[b].flavours.length; f++){
          let flavour_product_id = boxes_and_flavours[b].flavours[f].product_id;
          let flavour_variant_id = boxes_and_flavours[b].flavours[f].variant_id;
          let flavour_title = boxes_and_flavours[b].flavours[f].title;
          new_select_option += '<option value="' + flavour_variant_id + '" data-product-id="' + flavour_product_id + '">' + flavour_title + '</option>';
        }
        for (var i = 0; i < boxes_and_flavours[b].size; i++){
          flavour_number = i + 1;
          new_flavour_div += '<div id="flavour_' + flavour_number + '" class="flavour"><div class="dropdown"><h4>Flavour ' + flavour_number + '</h4><select id="flavour_dropdown_' + flavour_number + '" name="flavour_' + flavour_number + '">' + new_select_option + '</select></div><div class="information"><img src="" width="100" /><p class="description"></p></div></div>';
        }
      }
    }

    // Set data to HTML
    $('#step2 .flavour_selection').prepend(new_flavour_div);
    $('#step2 .buttons .confirm').attr('data-subscription-id',selected_subscription_id).attr('data-new-variant-id',available_box_id).attr('data-new-variant-price',available_box_price).attr('data-new-variant-title',available_box_title);
    
    // Set selected flavour image and description
    let new_flavours = [];
    for (var m = 0; m < boxes_and_flavours.length; m++) {
      if (boxes_and_flavours[m].variant_id == available_box_id) {
        for (var n = 0; n < boxes_and_flavours[m].flavours.length; n++){
          $('#flavour_' + (n+1) + ' .information img').attr('src', boxes_and_flavours[m].flavours[0].image);
          $('#flavour_' + (n+1) + ' .information p').html(boxes_and_flavours[m].flavours[0].description);
        }
      }
    }

    // CSS between step 1 and step 2
    $('#step1').animate({'top':'-999px','z-index':'-1'}, 100);
    $('#step2').animate({'top':'0','z-index':'0'}, 100);

    $('#step1').css('position','absolute');
    $('#step2').css('position','relative');

    setTimeout(function() {
      $(".modal__container").animate({ scrollTop: 0 }, 300);
    },300);
  });


  // On Available box click
  $('body').delegate('#step2 .buttons .go_back', 'click', function (e) {
    go_back_or_close();
  });

  // Change image and description upon selecting a flavour from the dropdown
  $('body').delegate('#step2 .flavour select', 'change', function (e) {
    const flavour_id = $(this).val();
    let flavour_dropdown_id = '#' + $(this).parent().parent().attr('id');
    for (var i = 0; i < boxes_and_flavours.length; i++) {
      for (var j = 0; j < boxes_and_flavours[i].flavours.length; j++) {
        if (boxes_and_flavours[i].flavours[j].variant_id == flavour_id) {
          let new_image = boxes_and_flavours[i].flavours[j].image;
          let new_description = boxes_and_flavours[i].flavours[j].description;
          $(flavour_dropdown_id).find('.information img').attr('src', new_image);
          $(flavour_dropdown_id).find('.information .description').html(new_description);
        }
      }
    }
  });

  $('body').delegate('#step2 .buttons .confirm.enabled', 'click', function (e) {
    const subscription_id = $(this).attr('data-subscription-id');
    const new_flavours_array = [];
    const new_product_and_flavours_array=[];

    $('#step2 .flavour_selection .flavour select option:selected').each(function () {
      new_flavours_array.push({
        'name': $(this).text(),
        'shopify_product_id': parseInt($(this).attr('data-product-id')),
        'shopify_variant_id': parseInt($(this).val())
      });
    });

    new_product_and_flavours_array.push({
      'shopify_variant_id': parseInt($(this).attr('data-new-variant-id')),
      'shopify_variant_title': $(this).attr('data-new-variant-title'),
      'price': parseFloat($(this).attr('data-new-variant-price')),
      'properties': JSON.stringify(new_flavours_array)
    });

    $(this).addClass('disabled').addClass('loader').text('');

    const new_product_and_flavours =  new_product_and_flavours_array;
    recharge_change_product_and_flavour(subscription_id, new_product_and_flavours)
  });

  var urlParam = getParameterByName('box_changed');
	if(urlParam == 'true'){
    const message = "Your m-eat! box has now been changed.<br />We hope you enjoy your new flavours.";
    $('#customer_tab_content').prepend('<div class="success"><p>'+message+'</p></div>');
    
    setTimeout(function() { 
      $('#customer_tab_content .success').fadeOut(1500, function() { $('#customer_tab_content .success').remove(); });
    }, 3000);
	}
}

/*
* --------------------- Delivery Schedule ---------------------
*/
function delivery_schedule() {
  // Custom text added for toggle on/off
	$('.rc_schedule__orders').parent().prepend('<p class="toggle_text">Toggle to pause/resume delivery.</p>')
	
	// Re-do delivery schedule layout as per designs
	$('.rc_schedule__order').each(function( index ) {
		
		// Get Selector
		var rc_schedule__order_index = index + 1;
		var rc_schedule__order = '.rc_schedule__order__'+rc_schedule__order_index;

		// Loop through each plan per order
		$(rc_schedule__order).find('tr.rc_schedule__order__item').each(function(index){

			// Set new layout per plan per order
			$(rc_schedule__order).append('<div class="plan"><div class="delivery_schedule"><div class="date_product"><div class="date"><i class="fas fa-chevron-down"></i></div><div class="product_name"></div></div><div class="delivery_toggle_wrapper"></div></div><div class="delivery_details"></div></div>');
						
			// Add unique class per plan per order
			$(rc_schedule__order).find('.plan').each(function(index){
				$(this).addClass('plan_' + index);
			});			
			
			$(rc_schedule__order).find('.plan_'+index+' .delivery_toggle_wrapper').append('<div class="delivery_toggle skip">Skip</div><div class="delivery_toggle unskip">Go</div>');
	
			// Create new table layout for plan
			$(rc_schedule__order).find('.plan_'+index+' .delivery_details').append('<table class="delivery_details_table rc_table"><thead><tr><th>Delivery Address</th><th>Product</th><th>Quantity</th><th>Price</th></tr></thead><tbody></tbody></table>');
			
			// Set Variables for each of the items of info
			var delivery_date = $(rc_schedule__order).find('.rc_schedule__order__date h4 strong').text().trim();
			var delivery_address = $(rc_schedule__order).find('.rc_schedule__order__address').html();
			var delivery_product = $(this).find('td[data-th="Products"]').text().replace('Skipped:','').replace('Biltong Box - ','').replace('Biltong Box  (Auto renew) - ','').replace(' (','<br />(').trim();
			var delivery_quantity = $(this).find('td.rc_text--right').first().text().trim();
			var delivery_price = $(this).find('td.rc_text--right').last().text().trim();
			var delivery_edit = $(this).find('.rc_schedule__order__item__skip').html();

			//index fix to display data
			var plans_per_order = index;
			if($(rc_schedule__order).find('tr.rc_schedule__order__item').length == 1){
				plans_per_order = index + 1;
			}
			
			// If Delivery Address is empty
			if(!delivery_address){
				delivery_address = 'N/A';
			}
			
			// Set data in new table layout
			$(rc_schedule__order).find('.delivery_details_table:nth-child('+plans_per_order+') tbody').append('<tr><td>'+delivery_address+'</td><td class="product"><p>'+delivery_product+'</p></td><td>'+delivery_quantity+'</td><td>£'+delivery_price+'</td></tr>');
			
			// Set Skip/Go toggle
			var delivery_status_skip = $(this).find('.rc_schedule__order__item__skip a').clone().text('');
			var delivery_status_text = $(delivery_edit).text().trim().toLowerCase();
			if(delivery_status_text == 'skip'){
				$(rc_schedule__order).find('.plan_'+index+' .skip').contents().wrap(delivery_status_skip);			
				$(rc_schedule__order).find('.plan_'+index+' .skip').addClass('active');
			} else if(delivery_status_text == 'unskip'){
				$(rc_schedule__order).find('.plan_'+index+' .unskip').contents().wrap(delivery_status_skip);			
				$(rc_schedule__order).find('.plan_'+index+' .unskip').addClass('active');
				$(rc_schedule__order).find('.plan_'+index+' .delivery_details').prepend('<p class="skipped">Skipped</span>');
			}
			
			// Set Date
			$(rc_schedule__order).find('.plan_'+index+' .delivery_schedule .date').append(delivery_date);
			
			// Set Product
			delivery_product_title = delivery_product.replace('Biltong Box  (Auto renew) - ','').replace('Biltong Box - ','').replace('Skipped:','').trim();
			$(rc_schedule__order).find('.plan_'+index+' .delivery_schedule .product_name').append(delivery_product_title.split('(')[0]);
			
			// Fetch current flavours for each future subscription
			setTimeout(function() { 
				var id = $(rc_schedule__order).find('.plan_'+index+' .delivery_toggle_wrapper a.toggle-delivery').data('item-id');
				var selector = $(rc_schedule__order).find('.plan_'+index+' .delivery_details_table td.product p');
        fetch_current_flavours(id, 'insertAfter', selector);
			}, 100);
		});
		
		// Delivery Schedule accordian
		var clickHandler = ('ontouchstart' in document.documentElement ? "touchstart" : "click");
		$(document).on(clickHandler, '.plan_'+index+' .date_product', function(e) {
			e.preventDefault();
			var accordian = '.'+$(this).parent().parent().parent().attr('class').split(' ').slice(-1);
			$(accordian).find('.plan_'+index+' .delivery_details').slideToggle(500);
			$(accordian).find('.plan_'+index+' .delivery_details').css('display','block');
			$(accordian).find('.plan_'+index+' .delivery_schedule').toggleClass('active_ds');
		});
		
		// Hide Recharge layout data
		$(rc_schedule__order).find('.rc_schedule__order__date').detach();
		$(rc_schedule__order).find('.rc_schedule__order__address').detach();
		$(rc_schedule__order).find('.rc_table__container').detach();
	});
}

/*
* --------------------- Billing Info ---------------------
*/	
function billing_info() {
	// Edited the billing page to match designs
	if(window.location.pathname.indexOf('/tools/recurring/') > -1) {
		if(window.location.pathname.indexOf('/delivery_schedule') < 0 && window.location.pathname.indexOf('/subscriptions') < 0) {
			$('#content__customers__billing table tr:first .rc_text--base p:last').addClass('edit').detach().appendTo('#content__customers__billing table tr:first td:first')
			$('#content__customers__billing table tr:last .rc_text--base p:last').addClass('edit').detach().appendTo('#content__customers__billing table tr:last td:first')
		}
  }
}

$(document).ready(function ($) {
  current_plans();
  delivery_schedule();
  billing_info();
  billingPortal();
});


//billing info page address change
function billingPortal(){
  var hash = getCookie('hash');
  $('.billing-portal a').attr("href", "https://m-eat.co.uk/tools/recurring/customers/" + hash);
  if( window.location.href.indexOf("/tools/recurring/customers/") > -1){
    console.log(111)
    var menuLink = $("#subscriptions-progress-wrapper ul li a");
    for( var i= 0; i < menuLink.length; i++){
      if( menuLink.eq(i).text() == "Current Plans"){
        menuLink.eq(i).attr("href", "https://m-eat.co.uk/account?view=subscriptions")
      }
      else if( menuLink.eq(i).text() == "Delivery Schedule"){
        menuLink.eq(i).attr("href", "https://m-eat.co.uk/account?view=schedule")
      }
    }
  }
  }
  var url = window.location.href ;
  if( url.includes("tools/recurring/customers/") == true && url.includes("subscriptions") == true){
    window.location.href = "https://m-eat.co.uk/account?view=subscriptions" 
  }